import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';

// --- MATA-CUCARACHAS PARA SAFARI ---
// Elimina Service Workers atascados ANTES de que Angular empiece a importar módulos
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Service Worker zombi desregistrado.')
    }
  }).catch(function(err) {
    console.log('Error desregistrando SW: ', err)
  })
}

// Arrancamos la aplicación
bootstrapApplication(AppComponent, appConfig).catch(console.error);